// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionReason-cls1_U3-","cls2":"SuggestionReason-cls2_5z6 SuggestionReason-cls1_U3-"};